import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { api } from "../lib/api";

const WHATSAPP_ICON = (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" aria-hidden="true">
    <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.87 9.87 0 0 0 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm0 18.03a8.1 8.1 0 0 1-4.13-1.13l-.3-.18-3.12.82.83-3.04-.2-.31a8.06 8.06 0 0 1-1.24-4.28c0-4.47 3.64-8.1 8.12-8.1a8.1 8.1 0 0 1 8.11 8.1c0 4.47-3.64 8.12-8.07 8.12zm4.45-6.07c-.24-.12-1.44-.71-1.66-.79-.22-.08-.39-.12-.55.12-.16.24-.63.79-.77.95-.14.16-.28.18-.53.06-.24-.12-1.03-.38-1.96-1.21-.72-.65-1.21-1.44-1.36-1.68-.14-.24-.01-.37.11-.5.11-.11.24-.28.37-.42.12-.14.16-.24.24-.4.08-.16.04-.31-.02-.43-.06-.12-.55-1.32-.75-1.81-.2-.48-.4-.41-.55-.42h-.47c-.16 0-.43.06-.65.31-.22.24-.86.84-.86 2.05 0 1.21.88 2.37 1 2.53.12.16 1.72 2.63 4.18 3.69.58.25 1.04.4 1.4.52.59.19 1.12.16 1.54.1.47-.07 1.44-.59 1.64-1.16.2-.57.2-1.05.14-1.16-.06-.1-.22-.16-.46-.28z" />
  </svg>
);

const REAL_ESTATE_PATHS = ["/real-estate", "/projects", "/site-visit", "/landowner-partnerships"];
const JEWELLERY_PATHS = ["/jewellery", "/wholesale-jewellery", "/jewellery-manufacturer", "/gold-jewellery", "/diamond-jewellery", "/bridal-jewellery"];

export default function WhatsAppFloat() {
  const [config, setConfig] = useState(null);
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  if (!config) return null;

  const path = location.pathname;
  const isRealEstate = REAL_ESTATE_PATHS.some((p) => path.startsWith(p));
  const isJewellery = !isRealEstate && JEWELLERY_PATHS.some((p) => path.startsWith(p));

  const number = isRealEstate
    ? config.whatsapp_realestate
    : config.whatsapp_jewellery || config.whatsapp_realestate;

  if (!number) return null;

  const message = isRealEstate
    ? "Hello RK Builders, I would like to enquire about a property."
    : isJewellery
      ? "Hello Ramesh Kapoor & Sons Jewellers, I would like to make an enquiry."
      : "Hello RK Group, I would like to make an enquiry.";

  const label = isRealEstate ? "Chat with RK Builders on WhatsApp" : "Chat with Ramesh Kapoor & Sons Jewellers on WhatsApp";

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          key={`wa-${isRealEstate}`}
          href={`https://wa.me/${number}?text=${encodeURIComponent(message)}`}
          target="_blank"
          rel="noreferrer"
          aria-label={label}
          data-testid="whatsapp-float"
          className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 z-40 flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#C5A059] text-[#05080E] shadow-[0_12px_32px_rgba(0,0,0,0.45)] hover:bg-[#d6b678] transition-colors duration-300"
          initial={{ opacity: 0, y: 16, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 16, scale: 0.9 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          whileHover={{ scale: 1.06 }}
        >
          {WHATSAPP_ICON}
        </motion.a>
      )}
    </AnimatePresence>
  );
}
